import React, { useContext, useState } from "react";
import styles from "../styles/ChatbotPreview.module.css";
import { LanguageContext } from "./App";

export const ChatbotPreview = ({
  firstMessage,
  header,
  subHeader,
  whatsapplink,
  telegramlink,
  mainColor,
  humanSpeech,
  aiSpeech,
  supportSpeech,
  backgroundColor,
  userInputColor,
  messageText,
  closeButton,
  enterEmailText,
}) => {
  const [sendButtonFilter, setSendButtonFilter] = useState("100%");
  const [sendButtonEmailColor, setSendButtonEmailColor] = useState(mainColor);
  const [sendButtonEmailArrow, setSendButtonEmailArrow] = useState(messageText);
  const [closeButtonColor, setCloseButtonColor] = useState(closeButton);
  const [language, setLanguage] = useContext(LanguageContext);

  return (
    <div>
      <button
        id={styles["chatButton"]}
        style={{
          backgroundColor: mainColor,
          marginBottom: 100,
        }}
      >
        <div id={styles["chat"]}>
          <svg
            id={styles["chat-bubble"]}
            width="100"
            height="100"
            viewBox="0 0 100 100"
          >
            <g id={styles["bubble"]}>
              <path
                className={styles["line4562334521-1"]}
                d="M 30.7873,85.113394 30.7873,46.556405 C 30.7873,41.101961 36.826342,35.342 40.898074,35.342 H 59.113981 C 63.73287,35.342 69.29995,40.103201 69.29995,46.784744"
              />
              <path
                className={styles["line4562334521-2"]}
                d="M 13.461999,65.039335 H 58.028684 C 63.483128,65.039335 69.243089,59.000293 69.243089,54.928561 V 45.605853 C 69.243089,40.986964 65.02087,35.419884 58.339327,35.419884"
              />
            </g>
            <circle
              className={styles["circle234562356"]}
              r="1.9"
              cy="50.7"
              cx="42.5"
            />
            <circle
              className={styles["circle234562356"]}
              cx="49.9"
              cy="50.7"
              r="1.9"
            />
            <circle
              className={styles["circle234562356"]}
              r="1.9"
              cy="50.7"
              cx="57.3"
            />
          </svg>
        </div>
      </button>

      <main>
        <div
          id={styles["chatbot-container"]}
          style={{
            backgroundColor: backgroundColor,
            marginBottom: 140,
          }}
        >
          <div id={styles["chatbot-header"]}>
            <div
              style={{
                flexDirection: "column",
                justifyContent: "center",
                marginTop: -6,
                marginLeft: -6,
              }}
            >
              <p
                id={styles["sub-heading-chatbot"]}
                style={{ color: mainColor }}
              >
                {header}
              </p>
              <p id={styles["sub-heading-ai"]} style={{ color: mainColor }}>
                {subHeader}
              </p>
              <div style={{ flexDirection: "row", margin: "0px" }}>
                {typeof language === "undefined" || language === "ru" ? (
                  <button
                    id={styles["operator-button"]}
                    style={{ backgroundColor: mainColor }}
                  >
                    Оператор
                  </button>
                ) : (
                  <button
                    id={styles["operator-button"]}
                    style={{ backgroundColor: mainColor }}
                  >
                    Call a human
                  </button>
                )}

                {whatsapplink !== "" || telegramlink !== "" ? (
                  <>
                    {whatsapplink !== "" ? (
                      <a
                        id={styles["whatsapp"]}
                        target="_blank"
                        href={whatsapplink}
                        rel="noreferrer"
                      >
                        WhatsApp
                      </a>
                    ) : null}

                    {telegramlink !== "" ? (
                      <a
                        id={styles["telegram"]}
                        target="_blank"
                        href={telegramlink}
                        rel="noreferrer"
                      >
                        Telegram
                      </a>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
            <div id={styles["close-container"]}>
              <div
                id={styles["leftright"]}
                style={{ background: closeButtonColor }}
                onMouseEnter={() => setCloseButtonColor("#f13f4a")}
                onMouseLeave={() => setCloseButtonColor(closeButton)}
              ></div>
              <div
                id={styles["rightleft"]}
                style={{ background: closeButtonColor }}
                onMouseEnter={() => setCloseButtonColor("#f13f4a")}
                onMouseLeave={() => setCloseButtonColor(closeButton)}
              ></div>
            </div>
          </div>
          <div
            style={{
              width: "200%",
              alignSelf: "center",
              height: 1,
              backgroundColor: "#bbb",
              marginTop: 5,
            }}
          ></div>
          <div id={styles["chatbot-conversation-container"]}>
            <div
              className={styles["speech"]}
              id={styles["first-message"]}
              style={{
                backgroundColor: aiSpeech,
                color: messageText,
                borderTopLeftRadius: 2,
                margin: "10px 10px 0 0",
              }}
            >
              {firstMessage}
            </div>
            <div
              className={styles["speech"]}
              style={{
                backgroundColor: humanSpeech,
                color: messageText,
                borderTopRightRadius: 2,
                margin: "10px 0 0 40px",
              }}
            >
              {language === "en" ? "Hi!" : "Привет!"}
            </div>
            <div
              className={styles["speech"]}
              style={{
                backgroundColor: aiSpeech,
                color: messageText,
                borderTopLeftRadius: 2,
                margin: "10px 10px 0 0",
              }}
            >
              {language === "en"
                ? "Hi! How can I help you today?"
                : "Здравствуйте! Чем я могу помочь сегодня?"}
            </div>
            <form
              style={{
                textAlign: "start",
                padding: "1em",

                maxWidth: "100%",
                fontSize: "15px",
                fontFamily: "Jost",
                fontWeight: 500,

                color: messageText,

                borderRadius: "20px",

                margin: "10px 5px 0 5px",
                background: aiSpeech,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",

                position: "relative",
              }}
            >
              {enterEmailText}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  marginTop: "3px",
                }}
              >
                <input
                  id={styles["emailInput"]}
                  placeholder="johndoe@email.com"
                ></input>
                <button
                  id={styles["arrow-button-email"]}
                  style={{
                    backgroundColor: sendButtonEmailColor,
                  }}
                  onMouseEnter={() => {
                    setSendButtonEmailColor(messageText);
                    setSendButtonEmailArrow(mainColor);
                  }}
                  onMouseLeave={() => {
                    setSendButtonEmailColor(mainColor);
                    setSendButtonEmailArrow(messageText);
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    console.log("Click placeholder");
                  }}
                >
                  <span
                    class={styles["arrow"]}
                    style={{
                      borderColor: sendButtonEmailArrow,
                      color: sendButtonEmailArrow,
                    }}
                  ></span>
                </button>
              </div>
            </form>
            <div
              className={styles["speech"]}
              style={{
                backgroundColor: supportSpeech,
                color: messageText,
                borderTopLeftRadius: 2,
                margin: "10px 10px 0 0",
              }}
            >
              <div style={{ fontSize: "10px" }}>
                {language === "en" ? "Staff member" : "Оператор"}{" "}
              </div>
              {language === "en"
                ? "I'm a staff member!"
                : "Привет! Я оператор!"}
            </div>
          </div>

          <form id={styles["form"]}>
            <input
              id={styles["user-input"]}
              required
              maxLength="300"
              style={{ color: userInputColor }}
              placeholder={language === "en" ? "Message..." : "Сообщение..."}
            />
            <button
              id={styles["arrow-button"]}
              style={{
                backgroundColor: mainColor,
                filter: `contrast(${sendButtonFilter})`,
              }}
              onMouseEnter={() => setSendButtonFilter("200%")}
              onMouseLeave={() => setSendButtonFilter("100%")}
              onClick={(e) => {
                e.preventDefault();
                console.log("Click placeholder");
              }}
            >
              <span className={styles["arrow"]}></span>
            </button>
          </form>
          <div
            style={{
              flexDirection: "row",
              display: "flex",
              justifySelf: "center",
              alignSelf: "center",
            }}
          >
            <a
              id={styles["other-text"]}
              style={{ color: userInputColor, textDecoration: "none" }}
            >
              {language === "en" ? "Powered by" : "Сделано с помощью"}{" "}
            </a>
            <a
              href="https://cyberchat.crd.co/"
              target="_blank"
              rel="noreferrer"
              id={styles["other-text-link"]}
              style={{ color: mainColor, textDecoration: "none" }}
            >
              CyberChat
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};
